import React, { useEffect, useRef, useState } from "react";
import {getNativeAppQueryParamsValuesByKey, isBplusRegistrationProcess, isEcoproRegistrationProcess, updateNativeAppQueryParams_LocalStorage } from "../../constants/AppMethod";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { setLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS, NATIVE_APP_SELECTION_ATTRIBUTE, SIGNUPTYPE } from "../../constants/AppConstants";
import NoTokenHandler from "./NoTokenHandler";
import Loader from "../../components/shared/loader/Loader";
import { useDispatch } from "react-redux";
import { NativeAppLogsInit } from "../../store/NativeAppLogs/NativeAppLogsSlice";
import AuthOnlyHandler from "./AuthOnlyHandler";

const PostLoginProcessHandler = React.memo(() => {
    const { inProgress, accounts } = useMsal();
    const dispatch = useDispatch();
    const [ready, setReady] = useState(false);
    const isAuthOnlyRef = useRef(false);
    /**
     * selection:  Attribute provided in query string, stating the service type
     *  - 1 = EcoPro
     *  - 2 = Bplus
     *  - 0 - Skip
     */
    const serviceTypeSelected = parseInt(getNativeAppQueryParamsValuesByKey("selection"));
    const IS_BPLUS_REGISTRATION_SERVICE = isBplusRegistrationProcess();
    const IS_ECOPRO_REGISTRATION_SERVICE = isEcoproRegistrationProcess();
    const appSelectionAttrArr = [NATIVE_APP_SELECTION_ATTRIBUTE.SKIP, NATIVE_APP_SELECTION_ATTRIBUTE.ECOPRO_SERVICE, NATIVE_APP_SELECTION_ATTRIBUTE.BPLUS_SERVICE];
    
    useEffect(() => {
        if(inProgress === InteractionStatus.None){
            let isAuthOnly = false;
             setLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID, accounts[0].idTokenClaims.sub);
            if(
                !appSelectionAttrArr.includes(serviceTypeSelected) 
                && !IS_BPLUS_REGISTRATION_SERVICE 
                && !IS_ECOPRO_REGISTRATION_SERVICE
            ){
                isAuthOnly = true;
            }
            isAuthOnlyRef.current = isAuthOnly;
            const payload = {'isOnlyAuth': isAuthOnly};
            updateNativeAppQueryParams_LocalStorage(payload);
            setReady(true);
        }
        if(serviceTypeSelected === NATIVE_APP_SELECTION_ATTRIBUTE.BPLUS_SERVICE || IS_BPLUS_REGISTRATION_SERVICE){
            setLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE, SIGNUPTYPE.BROTHER_PLUS);
        } else if(serviceTypeSelected === NATIVE_APP_SELECTION_ATTRIBUTE.ECOPRO_SERVICE){
            setLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE, SIGNUPTYPE.WEB);
        }
        dispatch(NativeAppLogsInit({isAppToWeb: true}));
        // eslint-disable-next-line 
    }, [inProgress]);

    return (
        (inProgress === InteractionStatus.None && ready)
        ? (isAuthOnlyRef.current) ? <AuthOnlyHandler /> : <NoTokenHandler />
        : <Loader />
    )
})

export default PostLoginProcessHandler;